const { pathToRegexp, compile } = require('path-to-regexp')

const tools = {
	getJsonFromUrl: function () {
		let result = {};
		if (typeof window.location !== 'undefined') {
			const query = window.location.search.substr(1);

			const list = query.split('?');
			for (let i = 0; i < list.length; i++) {
				list[i].split('&').forEach(function (part) {
					var item = part.split('=');
					result[item[0]] = decodeURIComponent(item[1]);
				});
			}
		}
		return result;
	},
	getFromUrlParam: function (variable) {
		const result = tools.getJsonFromUrl();
		return result[variable] || '';
	},
	getUrlHref: function () {
		let url = '';
		if (typeof window.location !== 'undefined') {
			url = encodeURIComponent(window.location.href) || '/';
		}
		return url;
	},
	gethostFromUrl: function () {
		let result = '';
		if (typeof window.location !== 'undefined') {
			result = window.location.host;
		}
		return result;
	},
	getPathnameFromUrl: function () {
		let result = '';
		if (typeof window.location !== 'undefined') {
			result = window.location.pathname;
		}
		return result;
	},
	gethashFromUrl: function () {
		let result = '';
		if (typeof window.location !== 'undefined') {
			result = window.location.hash.slice(1);
		}
		return result;
	},
	getJsonFromHash: function () {
		let result = {};
		if (typeof window.location !== 'undefined') {
			const query = window.location.hash.slice(1);
			query.split('&').forEach(function (part) {
				var item = part.split('=');
				try {
					result[item[0]] = decodeURIComponent(item[1]);
				} catch (e) {
					console.log(e);
				}
			});
		}
		return result;
	},
	getParamFromHash: function (key) {
		let result = {};
		if (typeof window.location !== 'undefined') {
			const query = window.location.search.substr(1);

			const list = query.split('?');
			for (let i = 0; i < list.length; i++) {
				list[i].split('&').forEach(function (part) {
					var item = part.split('=');
					result[item[0]] = item[1];
				});
			}
		}
		return result[key];
	},
	// emailRule: function (value) {
	// 	const rule = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	// 	return rule.test(value);
	// },
	// symbolLowercase: function (str) {
	// 	let newStr = '';
	// 	newStr = str.replace(/\，/g, ',');

	// 	return newStr;
	// },
	replaceHash: function (newHash) {
		const href = window.window.location.href,
			str = href.split('#');
		window.history.replaceState(undefined, undefined, str[0] + '#' + newHash);
	},
	isIE: function () {
		return /.*MSIE.*/.test(navigator.userAgent) || /.*Trident.*/.test(navigator.userAgent);
	},
	transformBreakToBr: function (str) {
		return str.replace(/\r\n|\n/g, '<br/>');
	},
	setPathToUrl: function (str) {
		window.history.pushState(null, null, str);
	},
	handleParam: function (segmentRefArr) {
		let param = '';
		if (segmentRefArr && segmentRefArr.length > 0) {
			param = '?';
			segmentRefArr.map((item, index) => {
				param = `${param}${index > 0 ? '&' : ''}segmentReference=${item}`;
				return true;
			});
		}
		return param;
	},
	downloadFile(data, type, fileName){
    var mimeTypes = {
          'csv': '.csv',
          'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        },
        isIE = tools.isIE(),
        blob = new Blob([data], {type: mimeTypes[type]});
    if (isIE){
      window.navigator.msSaveBlob(blob, fileName);
    }else{
      var objectUrl = URL.createObjectURL(blob);
      var a = document.getElementById('attachment-download');
      if(!a){
          a = document.createElement('a');
          a.id = 'attachment-download';
          document.body.appendChild(a);
          a.style = 'display: none';
      }
      a.href = objectUrl;
      a.download = fileName;
      a.click();
      setTimeout(function(){
        window.URL.revokeObjectURL(objectUrl);
      }, 100);
    }
	},
	generateLocaleUrl(locale, location) {
		const ROUTE = '/:locale/:path*';
		const definePath = compile(ROUTE);
		const routeComponents = pathToRegexp(ROUTE).exec(location);

		let subPaths = null;
		if (routeComponents && routeComponents[1]) {
			subPaths = routeComponents[1].split('/')
		}

		return definePath({
			locale,
			path: subPaths
		})
	}
};

export default tools;
